import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import FilterListRounded from "@mui/icons-material/FilterListRounded";
import CheckRounded from "@mui/icons-material/CheckRounded";
import { useLang } from "../i18n";

export default function PackageScopeSelect({ value, onChange, prefixes, disabled = false }) {
  const { t } = useLang();
  const prefixText = prefixes.join(", ");
  const selectedLabel = value === "all" ? t("s2.filter.all") : t("s2.filter.policy", { prefixes: prefixText });
  const options = [
    { value: "policy", title: t("s2.filter.policyTitle"), detail: t("s2.filter.policyDetail", { prefixes: prefixText }) },
    { value: "all", title: t("s2.filter.all"), detail: t("s2.filter.allDetail") },
  ];
  return <Select
    className="package-scope-filter"
    value={value}
    disabled={disabled}
    onChange={event => onChange(event.target.value)}
    inputProps={{ "aria-label": t("s2.filter") }}
    IconComponent={ExpandMoreRounded}
    startAdornment={<InputAdornment position="start"><FilterListRounded aria-hidden="true" sx={{ fontSize: 19, color: value === "policy" ? "var(--iio-signal)" : "var(--iio-text-3)" }} /></InputAdornment>}
    renderValue={() => <span title={selectedLabel}>{selectedLabel}</span>}
    sx={{
      height: 44, minWidth: 190, maxWidth: "min(300px, 100%)", borderRadius: "10px",
      fontFamily: "inherit", fontSize: 14, fontWeight: 600, color: "var(--iio-text-1)", background: "var(--iio-bg-1)",
      "& .MuiSelect-select": { py: "10px", pl: 0, pr: "36px !important", minWidth: 0 },
      "& .MuiSelect-icon": { color: "var(--iio-text-3)", right: 10 },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--iio-border)" },
      "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "var(--iio-text-3)" },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "var(--iio-signal)", borderWidth: 1 },
      "&.Mui-focused": { boxShadow: "0 0 0 3px color-mix(in srgb, var(--iio-signal) 16%, transparent)" },
    }}
    MenuProps={{
      anchorOrigin: { vertical: "bottom", horizontal: "right" },
      transformOrigin: { vertical: "top", horizontal: "right" },
      PaperProps: { className: "iio package-scope-menu", sx: {
        mt: 1, p: "4px", minWidth: 280, maxWidth: "calc(100vw - 32px)", borderRadius: "12px",
        backgroundColor: "var(--iio-bg-1)", backgroundImage: "none", color: "var(--iio-text-1)",
        border: "1px solid var(--iio-border)", boxShadow: "var(--iio-shadow-md)",
      } },
      MenuListProps: { "aria-label": t("s2.filter"), sx: { p: 0 } },
    }}
  >
    {options.map(option => <MenuItem key={option.value} value={option.value} sx={{
      display: "flex", gap: 2, minHeight: 64, px: "12px", py: "10px", borderRadius: "8px", whiteSpace: "normal",
      fontFamily: '"Source Sans 3", sans-serif', color: "var(--iio-text-1)",
      "&:hover, &.Mui-focusVisible": { backgroundColor: "var(--iio-bg-2)" },
      "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible": { backgroundColor: "color-mix(in srgb, var(--iio-signal) 9%, var(--iio-bg-1))" },
    }}>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: "block", fontSize: 14, fontWeight: 600 }}>{option.title}</span>
        <span style={{ display: "block", fontSize: 13, color: "var(--iio-text-3)", overflowWrap: "anywhere" }}>{option.detail}</span>
      </span>
      {value === option.value && <CheckRounded aria-hidden="true" sx={{ fontSize: 18, flexShrink: 0, color: "var(--iio-signal)" }} />}
    </MenuItem>)}
  </Select>;
}
